import { useSelector, useDispatch } from "react-redux";
import useBootstrap from "../../../../customHooks/useBootstrap.js";
import splitArrayInChunks from "../../../../utility/splitArrayInChunks.js";
import useRewards from "../../../../customHooks/useRewards.js";

import Reward from "../../../../components/Reward.js";

import { Container, Row, Col } from "reactstrap";

const MyRewardsCupons = ({}) => {

  const cupons = useRewards().cupons;
  const cuponsInChunks = splitArrayInChunks(cupons, 2);

  const { trashold6 } = useBootstrap();

  return (
    <div>
      <Container fluid className="p-0">
        {cuponsInChunks.map((chunk) => {
          const rowId = chunk
            .map((chunkElement) => chunkElement.promotion_id)
            .join("");
          return (
            <Row className="m-0" key={rowId} style={{ marginTop: "40px" }}>
              {chunk.map((chunkElement) => {
                return (
                  <Col
                    className="p-3"
                    {...trashold6}
                    key={chunkElement.promotion_id}
                  >
                    <Reward
                      name={chunkElement.promotion_name}
                      description={chunkElement.promotion_description}
                      image={chunkElement.image}
                      quantity={chunkElement.quantity}
                      discountText={chunkElement.discountText}
                      barcode={chunkElement.barcode}
                      validUntil={chunkElement.valid_until}
                    />
                  </Col>
                );
              })}
            </Row>
          );
        })}
      </Container>
    </div>
  );
};

export default MyRewardsCupons;
